/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TextArticleTIcon16Light } from './TextArticleTIcon16Light';
import { TextArticleTIcon16Regular } from './TextArticleTIcon16Regular';
import { TextArticleTIcon16Solid } from './TextArticleTIcon16Solid';
import { TextArticleTIcon20Light } from './TextArticleTIcon20Light';
import { TextArticleTIcon20Regular } from './TextArticleTIcon20Regular';
import { TextArticleTIcon20Solid } from './TextArticleTIcon20Solid';
import { TextArticleTIcon24Regular } from './TextArticleTIcon24Regular';
import { TextArticleTIcon24Solid } from './TextArticleTIcon24Solid';
import { TextArticleTIcon32Regular } from './TextArticleTIcon32Regular';
import { TextArticleTIcon64Regular } from './TextArticleTIcon64Regular';
var sizes = {
    16: {
        light: TextArticleTIcon16Light,
        regular: TextArticleTIcon16Regular,
        solid: TextArticleTIcon16Solid,
    },
    20: {
        light: TextArticleTIcon20Light,
        regular: TextArticleTIcon20Regular,
        solid: TextArticleTIcon20Solid,
    },
    24: {
        regular: TextArticleTIcon24Regular,
        solid: TextArticleTIcon24Solid,
    },
    32: {
        regular: TextArticleTIcon32Regular,
    },
    64: {
        regular: TextArticleTIcon64Regular,
    },
};
export var TextArticleTIcon = forwardRef('TextArticleTIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
